import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import AnnotationSequenceItem from '../AnnotationSequenceItem';

import { Wrapper, Box, Footer, Button } from './AnnotationSequence.style';

const AnnotationSequence = ({
  data = [],
  selectedPhotoDocument,
  isLoading = false,
  handleSelectPhotoDocument = () => {},
  handleSaveAnnotations = () => {},
}) => {
  const theme = useTheme();
  const intl = useIntl();

  const renderAnnotationSequenceBox = () => {
    const isSelected = (id) =>
      selectedPhotoDocument && String(selectedPhotoDocument.id) === String(id)
        ? true
        : false;

    return (
      <>
        {data && data.length > 0 ? (
          <Box theme={theme.annotationSequence.box}>
            {data.map(({ id, ...photoDocument }) => (
              <Fragment key={id}>
                <AnnotationSequenceItem
                  data={{ id, ...photoDocument }}
                  isSelected={isSelected(id)}
                  handleClick={(data) => handleSelectPhotoDocument(data)}
                />
              </Fragment>
            ))}
          </Box>
        ) : (
          ''
        )}{' '}
      </>
    );
  };

  const renderFooter = () => {
    return (
      <Footer>
        <Button
          theme={theme.button.default}
          widthAuto
          noMask
          tiny
          disabled={isLoading ? true : undefined}
          onClick={() => {
            if (!isLoading) handleSaveAnnotations();
          }}
        >
          {isLoading
            ? intl.formatMessage({ id: 'ANNOTATION_SEQUENCE.PLEASE_WAIT' })
            : intl.formatMessage({ id: 'ANNOTATION_SEQUENCE.SAVE_ALL' })}
        </Button>
      </Footer>
    );
  };

  return (
    <Wrapper>
      {renderAnnotationSequenceBox()}
      {renderFooter()}
    </Wrapper>
  );
};

AnnotationSequence.propTypes = {
  data: PropTypes.array,
  selectedPhotoDocument: PropTypes.object,
  isLoading: PropTypes.bool,
  handleSelectPhotoDocument: PropTypes.func,
  handleSaveAnnotations: PropTypes.func,
};

export default AnnotationSequence;
